import { TemplateSchema } from '@ametista-ai/api-schema';
import { ApiPaginatedResponse } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { templatesKeys } from './keys';

export function useTemplates() {
  return useQuery({
    queryKey: templatesKeys.list(),
    queryFn: async () => {
      const res = await apiClient.get<ApiPaginatedResponse<TemplateSchema>>(
        '/v1/templates',
        undefined
      );

      return [...res.data].sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
    },
  });
}
